module.exports = __webpack_public_path__ + "img/dlsjjkxt4.ff84329d.jpg";